import async from 'async';
import md5 from 'js-md5';

angular.module("SupportAgent")
.controller('RegisterController', function (
  $scope, EventHandler, $location, $q, $mdDialog,
  L,  U, INTRACTABLE, $rootScope, INTERACT) {
 $scope.registrationFailed = false;

 $scope.user={
  firstname:"",
  lastname:"",
  organization:""
 };

 $scope.validate_username = function valid_username(mv/*,vv*/) {
  return U.is_valid_email(mv) || U.is_valid_mobile(mv);
 };
 $scope.check_domain_availability = function domain_available(mv/*,vv*/) {
  if(!mv) return $q.reject();
  var rv = $q.defer();
  INTRACTABLE.request('domain/lookup', { name: mv }, function(e,r) {
   if(e) L.error({err:e,domain:mv},"error looking up the domain");
   if(r && r._S=='notfound') rv.resolve();
   else rv.reject();
  });
  return rv.promise;
 };

 $scope.validateRepPassword = function(){
  if($scope.password != $scope.reppassword) $scope.registrationForm.reppassword.$setValidity('password', false);
  else $scope.registrationForm.reppassword.$setValidity('password', true);
 };
 function show_alert(title,content) {
  $mdDialog.show(
   $mdDialog.alert()
   .title(title)
   .textContent(content)
   .ok($rootScope.strings.ok_btn)
  );
 }
 $scope.register = function register() {
  L.trace({u:$scope.username,p:$scope.password},"register attempt");
  $scope.registrationFailed = false;
  $scope.register_error_message="";
  if(!navigator.onLine) {
   $scope.register_error_message=$rootScope.strings.str_check_internet_connection;
   return;
  }
  if(!$rootScope.is_dynamic_domain_portal) {
   async.auto({
    connect: INTERACT.connect.bind(INTERACT,{domain:WTGCONFIG.domain}),
    create: ['connect',function register_create(r,cb) {
     INTERACT.create_account({
      acname: $scope.username,
      password: $scope.password
     },cb);
    }],
    device: ['create',function create_register_device(r,cb) {
     /* TODO: deduplicate similar code in interact module 1563031054 */
     INTERACT.register_device({
      name: md5(navigator.userAgent),
      type: INTERACT.D.client.typeweb
     },cb);
    }]
   },function(e,r) {
    if(e) {
     L.error({err:e,r:r},"error creating account");
     $scope.registrationFailed = true;
     return;
    }
    $rootScope.persist_login();
    $location.path('/');
   });
  } else {
   INTRACTABLE.request("domain/create",
   {
    "org":$scope.user.organization,
    "fn":$scope.user.firstname,
    "ln":$scope.user.lastname,
    "un":$scope.username,
    "pw":$scope.password
   },
   function(e, r) {
    if(e) {
     L.error({err:e},"error creating domain");
     return show_alert($rootScope.strings.str_heading_oops,
      $rootScope.strings.str_domain_create_failure);
    }
    if(r._S=='exists') return show_alert($rootScope.strings.str_heading_oops,
     $rootScope.strings.str_domain_create_exists);
    if(r._S!='ok') {
     L.error({r:r},"error creating domain");
     return show_alert($rootScope.strings.str_heading_oops,
      $rootScope.strings.str_domain_create_failure);
    }
    $scope.activators = {
     domain: $scope.user.organization,
     username: $scope.username,
     password: $scope.password
    };
    $scope.account_activation_hint=WTG.fmt($rootScope.strings.str_account_activation_hint,{destination:$scope.username});
   });
  }
 };

 $scope.do_activate = function() {
  $scope.register_error_message="";
  if(!navigator.onLine) {
   $scope.register_error_message=$rootScope.strings.str_check_internet_connection;
   return;
  }
  INTRACTABLE.request('user/confirm',{
   domainname: $scope.activators.domain,
   username: $scope.activators.username,
   token: $scope.activators.code
  },function(e,r) {
   if(e) {
    L.error({err:e},"activate error");
    return show_alert($rootScope.strings.str_heading_validate_token,
     $rootScope.strings.str_validate_token_error);
   }
   if(r._S!='ok') {
    L.error({r:r},"activate error");
    return show_alert($rootScope.strings.str_heading_validate_token,
     $rootScope.strings.str_validate_token_error);
   }
   INTERACT.U.login($scope.activators,function(e) {
    if(!e) $rootScope.persist_login();
    $location.path('/');
   });
  });
 };

});
